/**
 * Standard-Z-Index für den globalen Datei-Upload.
 * Bei geöffneter Projektübersicht (z-[310]+) darüber legen,
 * damit Drop-Overlay und Dialog sichtbar bleiben.
 */
export const GLOBAL_UPLOAD_Z = "z-[70]";
export const GLOBAL_UPLOAD_OVERLAY_Z = "z-[60]";

/** Über Projektübersicht / deren Overlays, unter sehr tiefen Timesheet-Nestings. */
export const GLOBAL_UPLOAD_OVER_OVERVIEW_Z = "z-[370]";
export const GLOBAL_UPLOAD_OVER_OVERVIEW_OVERLAY_Z = "z-[365]";
